// components/About.js (Updated)
import React from 'react';
import './About.css';
import { images } from '../utils/images';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Pragathi NGO</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              Founded in 2010, Pragathi NGO has been at the forefront of social change, 
              working tirelessly to uplift marginalized communities across India. Our 
              holistic approach addresses the root causes of poverty and inequality.
            </p>
            <p>
              We believe in empowerment through education, sustainable development, and 
              community participation. Our programs have touched the lives of over 50,000 
              individuals, creating lasting positive change.
            </p>
            <div className="stats">
              <div className="stat">
                <h3>15+</h3>
                <p>Years of Service</p>
              </div>
              <div className="stat">
                <h3>50,000+</h3>
                <p>Lives Impacted</p>
              </div>
              <div className="stat">
                <h3>25+</h3>
                <p>Active Programs</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <img src={images.about} alt="Community work" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;